import { render, staticRenderFns } from "./waterLevelFour.vue?vue&type=template&id=383ce4b5&scoped=true&"
import script from "./waterLevelFour.vue?vue&type=script&lang=js&"
export * from "./waterLevelFour.vue?vue&type=script&lang=js&"
import style0 from "./waterLevelFour.vue?vue&type=style&index=0&id=383ce4b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383ce4b5",
  null
  
)

export default component.exports